import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useBlogs } from '../common/BlogContext';
import './BlogList.css';

function BlogCard({ blog }) {
  const tags = blog.category
    ? blog.category.split(/[,\s]+/).filter(Boolean)
    : [];

  return (
    <div className="blog-card">
      <div className="blog-card__img-wrap">
        {blog.img ? (
          <img src={blog.img} alt={blog.title} className="blog-card__img" />
        ) : (
          <div className="blog-card__img-placeholder">
            <i className="ti ti-photo" aria-hidden="true"></i>
          </div>
        )}
        <div className="blog-card__overlay">
          <Link to={`/blog/${blog.id}`} className="blog-card__read-btn">
            Read Article
          </Link>
        </div>
      </div>
      <div className="blog-card__body">
        <div className="blog-card__meta">
          <div className="blog-card__tags">
            {tags.map((tag, i) => (
              <span key={i} className="blog-card__tag">{tag}</span>
            ))}
          </div>
          <span className="blog-card__date">
            <i className="ti ti-calendar-event" aria-hidden="true"></i>
            {blog.publish_date}
          </span>
        </div>
        <h3 className="blog-card__title">
          <Link to={`/blog/${blog.id}`}>{blog.title}</Link>
        </h3>
        {blog.body && (
          <p className="blog-card__excerpt">
            {blog.body.length > 120 ? blog.body.slice(0, 120) + '…' : blog.body}
          </p>
        )}
      </div>
    </div>
  );
}

function BlogList() {
  const { blogs } = useBlogs();
  const [search, setSearch] = useState('');
  const [activeTag, setActiveTag] = useState('All');

 const defaultTags = ['All', 'Architecture', 'Guide', 'Inspiration'];

const dynamicTags = [
  ...new Set(
    blogs.flatMap((b) =>
      b.category ? b.category.split(/[,\s]+/).filter(Boolean) : []
    )
  ),
];

// Merge default tags + any new tags from DB, no duplicates
const allTags = [
  ...defaultTags,
  ...dynamicTags.filter((t) => !defaultTags.includes(t)),
];
  const filtered = blogs.filter((b) => {
    const matchSearch =
      b.title.toLowerCase().includes(search.toLowerCase()) ||
      (b.category || '').toLowerCase().includes(search.toLowerCase());
    const matchTag =
      activeTag === 'All' ||
      (b.category || '').toLowerCase().includes(activeTag.toLowerCase());
    return matchSearch && matchTag;
  });

  return (
    <div className="blog-list-page">
      <div className="blog-list-page__header">
        <div className="blog-list-page__header-inner">
          <p className="blog-list-page__eyebrow">Our Journal</p>
          <h1 className="blog-list-page__heading">Insights &amp; Inspiration</h1>
          <p className="blog-list-page__sub">
            Architecture, interior design, and construction stories from around the world.
          </p>
          <div className="blog-list-page__header-links">
            <Link to="/" className="blog-list-page__home-link">
              <i className="ti ti-home" aria-hidden="true"></i> Home
            </Link>
            <Link to="/admin" className="blog-list-page__admin-link">
              <i className="ti ti-settings" aria-hidden="true"></i> Manage Blogs
            </Link>
          </div>
        </div>
      </div>

      <div className="blog-list-page__controls">
        <div className="blog-list-page__search-wrap">
          <i className="ti ti-search blog-list-page__search-icon" aria-hidden="true"></i>
          <input
            type="text"
            placeholder="Search articles..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="blog-list-page__search"
          />
        </div>
        <div className="blog-list-page__tags">
          {allTags.map((tag) => (
            <button
              key={tag}
              className={`blog-list-page__tag-btn${activeTag === tag ? ' active' : ''}`}
              onClick={() => setActiveTag(tag)}
            >
              {tag}
            </button>
          ))}
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="blog-list-page__empty">
          <i className="ti ti-article-off" style={{ fontSize: 40 }} aria-hidden="true"></i>
          <p>No articles found.</p>
          <Link to="/admin" className="blog-list-page__admin-link" style={{ marginTop: 16 }}>
            Add your first article →
          </Link>
        </div>
      ) : (
        <div className="blog-list-page__grid">
          {filtered.map((blog) => (
            <BlogCard key={blog.id} blog={blog} />
          ))}
        </div>
      )}
    </div>
  );
}

export default BlogList;